import * as generalActions from '../../actions/generalActions'
import * as receiptAction from '../../actions/receiptActions'
import * as resource from '../../constants/Resources'
import * as dataActions from '../../actions/dataActions'
import * as layoutAction from '../../actions/layoutActions'
import * as receiptActions from '../../actions/receiptActions'
import * as types from '../../constants/Types'
import { hashHistory } from 'react-router';
import { getObjectGroupList, setCurrentObjectGroup, setMessageBarText } from '../../objectmanagement/actions/objectManagementActions'
import * as receiptFunctions from '../../functions/ReceiptFunctions'
import * as general from '../../constants/General'
import * as keyFunctionActions from '../../actions/keyFunctionActions'
import * as functions from '../../constants/Functions'

export function confirmOrder() {
  return (dispatch) => {
      dispatch(keyFunctionActions.processFunction(functions.ObjectManagementClose));
  }
}

export function continueObjectManagementOpen(objectitem) {
	return (dispatch, getState) => {
		let selectedobjectitemid = 0;
		let selectedobjectitemreceiptnumber = 0;

		if (objectitem.Locked && !dispatch(dataActions.getLoggedInId(objectitem.LockedByUser))) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.OBJECT_OPEN_BY_CASHREGISTER)).format(objectitem.ItemNumber)));
			return;
		}
		selectedobjectitemid = objectitem.ObjectItemId;
		selectedobjectitemreceiptnumber = objectitem.ReceiptNumber;

		const receipt = getState().receiptState.receipt;

		if (selectedobjectitemreceiptnumber === 0) {
			if (receipt.receiptnumber != null && receipt.receiptnumber > 0) {
				dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN))));
			} else {
				dispatch(receiptAction.setObjectItem(selectedobjectitemid));
			}
		} else {
			dispatch(generalActions.loadingStart());
			dispatch(receiptAction.getReceiptByObjectItem(selectedobjectitemid)).then(() => {
				dispatch(generalActions.loadingEnd());
			});

			if (getState().layoutState.groups !== null) {
				dispatch(layoutAction.setGroup(getState().layoutState.groups.items[0].KeyLayoutGroupId))
      }
      
      hashHistory.push('/kiosk');
    }
			hashHistory.push('/kiosk');
	}
}

export function startCancelReceiptKiosk() {
  return (dispatch) => {
    dispatch(generalActions.setConfirmModal(dispatch(dataActions.getTranslation(resource.MODAL_CANCEL_RECEIPT)), cancelReceipt, null));
  }
}

function cancelReceipt() {
  return (dispatch, getState) => {
    if(getState().receiptState.receipt.lines.some(l => l.linetype === types.PAYMENT_LINE)){
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.CANCEL_RECEIPT_NOT_ALLOWED))));
      dispatch(generalActions.loadingEnd());
      return;
    }
    if (getState().receiptState.receipt.previousLines) {
      // if there are previousLines, this means we opened a table. In that case, we cannot cancel
      // the receipt (food has been prepared and/or served). All we can do is close the receipt without saving the new lines.
      dispatch(receiptActions.closeReceipt(true, true));
    }
    else {
      const receipt = dispatch(receiptFunctions.saveReceipt());

      dispatch(generalActions.loadingStart());
      fetch(general.API_URL_CANCEL_RECEIPT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(receipt)
      })
        .then(response => generalActions.checkLicense(response, dispatch))
        .then(() => {
          dispatch(receiptActions.emptyReceipt(true));
          dispatch(receiptActions.resetInputQuantity());

          const pos = dispatch(dataActions.getPos(getState().generalState.posId));
          if (pos !== null
            && pos.ObjectManagementRequired) {
            dispatch(processObjectManagementOpen());
          }

          dispatch(generalActions.loadingEnd());
        });
    }
  }
}

function processObjectManagementOpen() {
	return (dispatch, getState) => {
		const receiptNumber = getState().receiptState.receipt.receiptnumber
		if (receiptNumber >= 0 && receiptNumber != null) {
			const message = dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN));
			dispatch(generalActions.setMessageModal(true, message));
			return;
		}
     const posid = getState().generalState.posId
		dispatch(generalActions.loadingStart());
		dispatch(getObjectGroupList(posid)).then(() => {
			const objectGroups = getState().objectManagementState.objectgroups;
			if (objectGroups.length > 0) {
				dispatch(setCurrentObjectGroup(objectGroups[0].ObjectGroupId));
			}
			dispatch(setMessageBarText(dispatch(dataActions.getTranslation(resource.CHOOSE_OBJECT))));
			dispatch(generalActions.loadingEnd());

			hashHistory.push('/kiosk');
		});
	}
}

export function createOrder() {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    const posid = getState().generalState.posId;
    dispatch(getObjectGroupList(posid)).then(() => {
      const objectGroups = getState().objectManagementState.objectgroups;
      const currentObjectGroupId = getState().generalState.posList.find(x => x.PosId === getState().generalState.posId).ObjectGroupId;
      const currObjectGroup =  objectGroups.find(x => x.ObjectGroupId === currentObjectGroupId);

    // Get first available objectItem
     const objectItem = dispatch(getFirstAvailableObjectItem(currObjectGroup));
     if(objectItem != null)
     {
       dispatch(continueObjectManagementOpen(objectItem));
       dispatch(receiptActions.createReceiptObjectManagement(false, objectItem.ObjectItemId));
       dispatch(generalActions.loadingEnd());
     } else {
       dispatch(generalActions.loadingEnd());
       dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_OBJECTS_AVAILABLE))));
      }
    });
  }
}

export function createReceipt() {
  return (dispatch, getState) => {
    const receiptNumber = getState().receiptState.receipt.receiptnumber;
    if (receiptNumber >= 0 && receiptNumber != null) {
			const message = dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN));
			dispatch(generalActions.setMessageModal(true, message));
			return;
    }

    dispatch(generalActions.loadingStart());
    dispatch(receiptActions.createReceipt(false)).then(() => {
      dispatch(generalActions.loadingEnd());
    }).then(() => {
      if (getState().layoutState.groups !== null) {
        dispatch(layoutAction.setGroup(getState().layoutState.groups.items[0].KeyLayoutGroupId))
      }
    });
  }
}

function getFirstAvailableObjectItem(objectGroup) {
  return function()
  {
    let result = null;
    const objectItems = objectGroup.ObjectItems;
    for(let i = 0; i < objectItems.length; i++) {
      if(objectItems[i].ReceiptNumber === 0) {
        result = objectItems[i];
        break;
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// src/kiosk/actions/kioskActions.js